import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrl: './communication.component.scss'
})
export class CommunicationComponent {

  @Input() communicationData: any
  @Output() changeModalState = new EventEmitter<any>();

  documents = false;
  call = true;
  receipt = false;
  note = true;
  email = true;
  sms = true;
  addSMS = false
  cammuni = true;
  messages: string[] = []; // Array to store messages
  newMessage: string = '';

  callIcon = true;
  noteIcon = true;
  emailIcon = true;
  smsIcon = true;
  fadecallIcon = false;
  fadenoteIcon = false;
  fadeemailIcon = false;
  fadesmsIcon = false;
  plusIcon = false;

  constructor() { }

  ngOnInit() {
  }

  // Calls Fuctionality Show & Hide
  Calls() {
    this.call = !this.call
    this.callIcon = !this.callIcon
    this.fadecallIcon = !this.fadecallIcon
  }

  // Recipt Fuctionality Show & Hide
  Recipt() {
    this.receipt = true
    this.cammuni = false
    this.documents = false
  }

  // Notes Fuctionality Show & Hide
  Notes() {
    this.note = !this.note
    this.noteIcon = !this.noteIcon
    this.fadenoteIcon = !this.fadenoteIcon
  }

  // Emails Fuctionality Show & Hide
  Emails() {
    this.email = !this.email
    this.emailIcon = !this.emailIcon
    this.fadeemailIcon = !this.fadeemailIcon
  }

  // SMS Fuctionality Show & Hide
  SMSS() {
    this.sms = !this.sms
    this.smsIcon = !this.smsIcon
    this.fadesmsIcon = !this.fadesmsIcon
  }

  PlushIcon() {
    this.plusIcon = !this.plusIcon
  }

  showSMS(){
    this.addSMS = true
  }

  /**
   * Click Close Model Form
   */
  Close() {
    this.changeModalState.emit({
      "showCommunicationPanel": false
    });
  }

  /**
  * Messange Type &  Send
  */
  sendMessage() {
    if (this.newMessage.trim() !== '') {
      this.messages.push(this.newMessage.trim());
      this.newMessage = ''; // Clear the input field after sending
    }
  }
}